<script>
    import Template from '{Template}/Web/Pages/Dashboard.template'
    import ThemeMode from '../Components/ThemeMode.vue';

    import AppLayout from '@/Layouts/AppLayout'
    import Welcome from '@/Jetstream/Welcome'
    import LanguageSwitcher from '@/Components/LanguageSwitcher'
    
    import MarketMixin from "@/Mixins/Market/MarketMixin";
    import { Hooper, Slide } from 'hooper';
    import 'hooper/dist/hooper.css';

    export default Template({
        components: {
            AppLayout,
            Welcome,
            LanguageSwitcher,
            Hooper,
            Slide,
	    ThemeMode
	    
        },
        data() {

            return {

		isDarkTheme: false,				 
		 isMobile: false,
		 isTablet: false,
		email: '',			
		 videoUrl: 'https://bitzipp.pro/storage/uploads/future.mp4',
                sliderElements: 4,
                isMobile: false,
                hooperSettings: {
                    itemsToShow: 4,
                    vertical: false,
                    autoPlay: true,
                    touchDrag: true,
                    mouseDrag: true,
                    playSpeed: 3000,
                    infiniteScroll: true,
                    breakpoints: {
                        270: {
                            itemsToShow: 1,
                        },
                        700: {
                            itemsToShow: 3,
                        },
                        900: {
                            itemsToShow: 3,
                        },
                    }
                }
            }
        },
        props: {
            articles: Object,
	   
        },

        created() {
	    this.isDarkTheme = this.$page.props.theme === 'dark';
            window.addEventListener("resize", this.sliderListener);
        },
        destroyed() {
            window.removeEventListener("resize", this.sliderListener);
        },
        methods: {

	

	 toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
	this.$refs.myVideo.load();
    },

	     updateTheme() {
	console.log('Before theme toggle - isDarkTheme:', this.isDarkTheme);
      this.isDarkTheme = !this.isDarkTheme;
	 console.log('After theme toggle - isDarkTheme:', this.isDarkTheme);
      this.setThemeMode(this.isDarkTheme ? 'dark' : 'light');
    },
    setThemeMode(mode) {
      // Your existing logic to set the theme mode
      console.log('Setting theme mode to:', mode);
    },

	 isMobile() {
              return screen.width <= 767;
               
           
        },

	isTablet() {
              return window.innerWidth >= 768 && window.innerWidth <= 1023;


        },

	     saveAndRedirect() {
      // Save the email in a cookie
      document.cookie = `userEmail=${this.email}; max-age=3600;`;

      // Your logic to determine where to redirect
      const redirectPath = '/register'; // Change this based on your requirements

      // Redirect using Inertia.js
      this.$inertia.visit(redirectPath);
    },
	
	   

            sliderListener() {
                if(window.innerWidth >= 767) {
                    this.sliderElements = 3;
                    this.isMobile = false;
                } else {
                    this.sliderElements = 2;
                    this.isMobile = false;
                }
            },
            setArticle(article) {
                this.$inertia.visit(route('article', article.id));
            },
        },
        computed: {

	videoSource() {
      return this.isDarkTheme ? 'https://bitzipp.pro/storage/uploads/videobzpb.mp4' : 'https://bitzipp.pro/storage/uploads/videobzpw.mp4';
    },

		isDarkTheme() {
      // Compute isDarkTheme based on the current theme mode
      return this.$page.props.theme === 'dark';
    },

	       sliderMarkets: function () {

                let markets = this.$store.getters.getMarkets;

                if(markets && markets.length) {
                    return _.chunk(_.orderBy(markets, (market) => {
                        return parseFloat(market['name']);
                    }, 'desc'), this.sliderElements);
		   
                }
	    },

               topMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['volume']);
                }, 'desc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             },

	       gainMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['change']);
                }, 'desc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             },

	      btcMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['id']);
                }, 'asc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             },

		newMarkets: function () {
                 let markets = this.$store.getters.getMarkets;

                  if (markets && markets.length) {
                  // Sort the markets array by the criteria you want (e.g., volume)
                      const sortedMarkets = _.orderBy(markets, (market) => {
                  return parseFloat(market['date']);
                }, 'desc');

                 // Slice the sorted array to get only the top five markets
                  return sortedMarkets.slice(0, 5);
                }
                 // If there are no markets, return an empty array or handle it as needed
                return [];
             }
	       
                

        },
        mixins: [MarketMixin],
        mounted() {

		

		 this.isDarkTheme = this.$page.props.theme === 'dark';

  this.$root.$on('updateTheme', (mode) => {
    this.isDarkTheme = mode === 'dark';
    console.log('Updated theme in TDashboard:', this.isDarkTheme);
  });


		 this.isMobile = window.matchMedia('(max-width: 767px)').matches;	
		console.log('isMobile:', this.isMobile);

		this.isTablet = window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches;
		console.log('isTablet:', this.isTablet);
	
            //this.sliderListener();

            if(_.isEmpty(this.markets)) {
                this.$store.dispatch('fetchMarkets');
            }

            if(!this.$page.props.alt) {
                window.TyperSetup();
            }
        },

	watch: {
    '$page.props.theme'(newTheme) {
      this.isDarkTheme = newTheme === 'dark';
    },
  },

    });
</script>
